import styled from 'styled-components'

import { Collapse } from '@/components/ui/collapse'

export const CapitalizedText = styled.span(() => ({
  textTransform: 'capitalize',
}))

// Note: see reservations.page.styled.ts's `AnalyticsCollapse` for why this is needed -
// Collapse's root has `overflow: hidden`, which resolves its flex automatic min-height to 0
// and makes it the first thing a flex-column ancestor shrinks when content overflows.
export const AnalyticsCollapse = styled(Collapse)`
  flex-shrink: 0;
`
